import React from 'react';

import { ImportOnVisibility } from '@lumapps/lumx-suspense/components/ImportOnVisibility';
import { WidgetSkeletonRectangle } from '@lumapps/widget-base/components/WidgetSkeleton/WidgetSkeletonRectangle';

import { ClientComputedMicroAppProps } from '../../types';

/**
 * This component lazily loads the ClientComputedMicroApp component and renders it when it becomes visible in the viewport.
 * It uses ImportOnVisibility to improve initial load time and provides a skeleton as a loading fallback.
 */
const ClientComputedMicroApp = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-micro-app' */
            './ClientComputedMicroApp'
        ),
);

/**
 * Lazy loaded wrapper for the ClientComputedMicroApp component.
 */
const LazyClientComputedMicroApp: React.FC<ClientComputedMicroAppProps> = (props) => (
    <ImportOnVisibility loadingFallback={<WidgetSkeletonRectangle />} rootProps={{ style: { height: '100%' } }}>
        <ClientComputedMicroApp {...props} />
    </ImportOnVisibility>
);

export { LazyClientComputedMicroApp as ClientComputedMicroApp };
